import { painelSurfaceClass, painelDescriptionClass, painelDescriptionMutedClass } from '@/components/painel/painel-styles';
import { cn } from '@/lib/utils';
import { painelLabelForSlug } from './painel-nav';

type PainelSectionPlaceholderProps = {
  slug: string;
};

export function PainelSectionPlaceholder({ slug }: PainelSectionPlaceholderProps) {
  const label = painelLabelForSlug(slug);

  return (
    <div className="space-y-4">
      <div>
        <h1 className="font-poppins text-2xl font-bold tracking-tight text-white md:text-3xl">
          {label}
        </h1>
        <p className={cn('mt-1 font-inter text-sm', painelDescriptionClass)}>
          Área em desenvolvimento para gerenciar {label.toLowerCase()}. Em breve você terá ferramentas completas
          aqui.
        </p>
      </div>
      <div
        className={cn(
          painelSurfaceClass,
          'border-dashed border-white/20 bg-blue-950/35 px-6 py-16 text-center'
        )}
      >
        <p className="font-poppins text-sm font-medium text-white">
          Funcionalidade em desenvolvimento
        </p>
        <p className={cn('mt-2 font-inter text-xs', painelDescriptionMutedClass)}>
          A navegação e o layout já estão prontos para ganhar novas funções.
        </p>
      </div>
    </div>
  );
}
